import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';
import ppWovenBagsImage from '../assets/pp-woven-bags.jpg';
import industryImage from '../assets/industry-image.jpg';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "MAHARAJA POLYFAB LIMITED",
      subtitle: "Forging the Future of Flexible Packaging in India",
      description: "We deliver strength, sustainability, and superior branding through high-quality PP Woven and BOPP packaging solutions.",
      cta: { primary: "Explore Our Products", secondary: "Investor Insights" },
      image: ppWovenBagsImage,
      imageAlt: "PP woven bags packaging solution"
    },
    {
      id: 2,
      title: "State-of-the-Art Manufacturing",
      subtitle: "6,800 MT Installed Capacity • 95.0% Utilization",
      description: "BOPP Rotogravure Printing Machine & Clean Factory Floor Operations with 30 Million+ Bags Produced.",
      cta: { primary: "View Manufacturing", secondary: "Our Certifications" },
      image: industryImage,
      imageAlt: "Industrial packaging manufacturing setup"
    }
  ];

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }, [slides.length]);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 8000); // Auto-rotate every 8 seconds
    return () => clearInterval(interval);
  }, [nextSlide]);

  return (
    <section id="home" className="hero">
      <div className="hero-slideshow">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
          >
            <div className="container">
              <div className="hero-content">
                <div className="hero-panel">
                  <div className="hero-text">
                    <h1 className="hero-title">{slide.title}</h1>
                    <p className="hero-subtitle">{slide.subtitle}</p>
                    <p className="hero-recycled-line">Our products are 100% recycled</p>
                    <p className="hero-description">{slide.description}</p>

                    <div className="hero-actions">
                      {slide.cta.primary === "View Manufacturing" ? (
                        <Link to="/about/manufacturing" className="btn btn-primary">
                          {slide.cta.primary}
                        </Link>
                      ) : (
                        <Link to="/products" className="btn btn-primary">
                          {slide.cta.primary}
                        </Link>
                      )}
                      {slide.cta.secondary === "Our Certifications" ? (
                        <Link to="/about/quality" className="btn btn-secondary">
                          {slide.cta.secondary}
                        </Link>
                      ) : (
                        <a href="#investor" className="btn btn-secondary">
                          {slide.cta.secondary}
                        </a>
                      )}
                    </div>
                  </div>

                  <div className="hero-visual">
                    <img src={slide.image} alt={slide.imageAlt} className="hero-slide-image" />
                    <div className="hero-visual-caption">
                      PP Woven & BOPP Packaging
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        <div className="slideshow-nav">
          <button className="nav-arrow prev" onClick={prevSlide}>
            <i className="fas fa-chevron-left"></i>
          </button>
          <button className="nav-arrow next" onClick={nextSlide}>
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>

        <div className="slideshow-indicators">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
            ></span>
          ))}
        </div>
      </div>

      <div className="hero-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">6,800 MT</div>
              <div className="stat-label">Installed Capacity</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">95.0%</div>
              <div className="stat-label">Capacity Utilisation</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50M+</div>
              <div className="stat-label">Bags Produced Per Annum</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">170+</div>
              <div className="stat-label">Permanent Employees</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
